export interface VideoCategory {
  id: string;
  name: string;
  slug: string;
  description: string;
  imageUrl: string;
  count: number;
}

export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  publishDate: string;
  imageUrl: string;
  tags: string[];
  views: number;
}

export interface FAQ {
  question: string;
  answer: string;
}

export interface Milestone {
  year: string;
  title: string;
  description: string;
}

export interface TeamMember {
  name: string;
  role: string;
  bio: string;
  imageUrl: string;
}

export const categories: VideoCategory[] = [
  {
    id: 'mitao',
    name: '蜜桃视频',
    slug: 'mitao',
    description: '蜜桃般甜蜜的观影体验，汇聚最受欢迎的甜蜜内容，每日更新海量高清视频资源，给你最温暖的陪伴。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20soft%20pastel%20peach%20fruit%20themed%20background%20with%20warm%20gradients%20and%20dreamy%20atmospheric%20lighting%2C%20cinematic%20bokeh%20effects%2C%20smooth%20gradient%20texture%2C%20soft%20focus%20minimalist%20composition&width=600&height=400&seq=mitao-cat&orientation=landscape',
    count: 1280,
  },
  {
    id: 'taozi',
    name: '桃子视频',
    slug: 'taozi',
    description: '鲜嫩多汁的精彩内容，桃子视频带来清新鲜活的观影感受，精选优质片源，让每一帧都充满活力。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20soft%20pastel%20pink%20fruit%20themed%20background%20with%20warm%20gradients%20and%20dreamy%20atmospheric%20lighting%2C%20cinematic%20bokeh%20effects%2C%20smooth%20gradient%20texture%2C%20soft%20focus%20minimalist%20composition&width=600&height=400&seq=taozi-cat&orientation=landscape',
    count: 960,
  },
  {
    id: 'pingguo',
    name: '苹果视频',
    slug: 'pingguo',
    description: '经典永不过时，苹果视频传承经典观影文化，汇集口碑佳作与热门大片，品质始终如一。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20soft%20warm%20red%20fruit%20themed%20background%20with%20gentle%20gradients%20and%20dreamy%20atmospheric%20lighting%2C%20cinematic%20bokeh%20effects%2C%20smooth%20gradient%20texture%2C%20soft%20focus%20minimalist%20composition&width=600&height=400&seq=pingguo-cat&orientation=landscape',
    count: 1560,
  },
  {
    id: 'liulian',
    name: '榴莲视频',
    slug: 'liulian',
    description: '榴莲般让人流连忘返，独特魅力让人欲罢不能，汇聚小众精品与独特内容，给你不一样的观影体验。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20soft%20warm%20golden%20yellow%20fruit%20themed%20background%20with%20gentle%20gradients%20and%20dreamy%20atmospheric%20lighting%2C%20cinematic%20bokeh%20effects%2C%20smooth%20gradient%20texture%2C%20soft%20focus%20minimalist%20composition&width=600&height=400&seq=liulian-cat&orientation=landscape',
    count: 720,
  },
  {
    id: 'mangguo',
    name: '芒果视频',
    slug: 'mangguo',
    description: '金黄灿烂的视觉盛宴，芒果视频以阳光般温暖的色调呈现精彩内容，给你满满的正能量。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20soft%20warm%20orange%20yellow%20fruit%20themed%20background%20with%20gentle%20gradients%20and%20dreamy%20atmospheric%20lighting%2C%20cinematic%20bokeh%20effects%2C%20smooth%20gradient%20texture%2C%20soft%20focus%20minimalist%20composition&width=600&height=400&seq=mangguo-cat&orientation=landscape',
    count: 1100,
  },
  {
    id: 'tangguo',
    name: '糖果视频',
    slug: 'tangguo',
    description: '五彩缤纷的甜蜜世界，糖果视频汇集轻松愉快的趣味内容，随时随地给你好心情。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20soft%20colorful%20candy%20themed%20background%20with%20warm%20gradients%20and%20dreamy%20atmospheric%20lighting%2C%20cinematic%20bokeh%20effects%2C%20smooth%20gradient%20texture%2C%20soft%20focus%20minimalist%20composition&width=600&height=400&seq=tangguo-cat&orientation=landscape',
    count: 850,
  },
];

export const articles: Article[] = [
  {
    id: 'art-1',
    title: '蜜桃视频年度精选：2026上半年最受欢迎的高清影片TOP10',
    slug: 'mitao-2026-top10',
    excerpt: '为大家盘点蜜桃视频平台2026年上半年最受观众喜爱的十部高清影片，涵盖动作、爱情、喜剧等多种类型，每部都值得反复回味。',
    content: `<p>2026年已经过半，蜜桃视频平台的观众们用他们的点击和收藏，为我们选出了上半年最值得观看的十部高清影片。今天，糖心视频就为大家带来这份精心整理的榜单。</p>
<h4>1. 《春风十里》</h4><p>这部都市爱情片以细腻的情感描绘和唯美的画面征服了无数观众。超清画质下，每一个微表情都清晰可见，让人沉浸其中无法自拔。影片讲述了两个年轻人在大城市中相遇、相知、相爱的故事，充满了温暖与感动。</p>
<h4>2. 《极速追凶》</h4><p>作为一部硬核动作片，《极速追凶》以紧凑的剧情和震撼的视觉效果获得了观众的广泛好评。桃子视频提供的高码率版本让每一个动作场面都流畅无比，观影体验堪称完美。</p>
<h4>3. 《糖果小镇》</h4><p>这部温馨治愈的动画电影以其独特的艺术风格和温暖人心的故事赢得了全家观众的喜爱。糖果视频平台的色彩还原度极高，让这部视觉盛宴得到了最好的呈现。</p>
<h4>4. 《深海迷踪》</h4><p>科幻悬疑大片，榴莲视频独家提供4K超清版本。影片构造了一个令人叹为观止的海底世界，想象力丰富，剧情层层反转，让观众大呼过瘾。</p>
<h4>5. 《苹果树下》</h4><p>文艺片佳作，苹果视频平台的口碑之作。以极简的叙事风格讲述了一个关于家庭、记忆与和解的动人故事。影片摄影精美，每一帧都像是一幅油画。</p>
<p>以上就是2026上半年蜜桃视频最受欢迎的五部影片。想观看完整片单？马上打开糖心视频，超清画质极速播放，畅享甜蜜观影体验！</p>`,
    category: 'mitao',
    categoryName: '蜜桃视频',
    author: '糖心编辑',
    publishDate: '2026-07-15',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20cinematic%20film%20reel%20and%20video%20streaming%20abstract%20background%20with%20warm%20peach%20and%20coral%20gradients%2C%20soft%20dreamy%20bokeh%20lights%2C%20smooth%20gradient%20texture%2C%20atmospheric%20composition&width=800&height=450&seq=art-1&orientation=landscape',
    tags: ['蜜桃视频', '年度精选', '高清影片', '观影推荐'],
    views: 25680,
  },
  {
    id: 'art-2',
    title: '桃子视频全新升级：4K超清画质带来前所未有的观影体验',
    slug: 'taozi-4k-upgrade',
    excerpt: '桃子视频平台全面升级至4K超清画质标准，配合AI画质增强技术，让每一帧画面都栩栩如生，观影沉浸感大幅提升。',
    content: `<p>糖心视频旗下桃子视频平台近日完成了全面的技术升级，正式支持4K超清画质播放。这一重大升级将为广大用户带来前所未有的观影体验。</p>
<h4>技术突破：AI画质增强</h4><p>桃子视频团队引入了最新的AI画质增强算法，能够智能识别画面中的细节信息，对色彩、对比度和清晰度进行实时优化。即使原始片源画质一般，经过AI处理后也能呈现出接近超清的视觉效果。</p>
<h4>流畅播放：极速缓存技术</h4><p>配合4K超清画质，桃子视频同时升级了底层播放引擎，采用新一代极速缓存技术。即使在网络环境一般的情况下，也能保证视频的流畅播放，不会出现卡顿或缓冲过久的问题。</p>
<h4>设备兼容：全平台覆盖</h4><p>无论是手机、平板还是电脑，无论是iOS还是Android系统，桃子视频的4K超清播放功能均已全面适配。用户只需升级到最新版本，即可享受超清画质带来的视觉盛宴。</p>
<h4>内容升级：海量4K片源</h4><p>桃子视频与全球多家内容制作方达成合作，引入了大量原生4K片源，涵盖电影、电视剧、纪录片、综艺等多种类型。未来还将持续扩充4K内容库，让用户尽享超清观影乐趣。</p>
<p>糖心视频始终致力于为用户提供极致的观影体验。桃子视频的这次全面升级，再次印证了我们在视频技术领域的领先地位。现在就来桃子视频，感受4K超清画质的魅力吧！</p>`,
    category: 'taozi',
    categoryName: '桃子视频',
    author: '糖心科技',
    publishDate: '2026-07-10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20cinematic%204K%20video%20technology%20abstract%20background%20with%20warm%20pink%20gradients%2C%20soft%20dreamy%20bokeh%20lights%2C%20smooth%20gradient%20texture%2C%20digital%20streaming%20theme&width=800&height=450&seq=art-2&orientation=landscape',
    tags: ['桃子视频', '4K超清', '技术升级', 'AI画质增强'],
    views: 18920,
  },
  {
    id: 'art-3',
    title: '苹果视频经典重温：那些年我们追过的港片黄金时代',
    slug: 'pingguo-hk-classics',
    excerpt: '苹果视频特推出港片经典回顾专题，收录了上世纪八九十年代的经典香港电影，带观众重温那段辉煌的港片黄金岁月。',
    content: `<p>香港电影的黄金时代，是一代人心中永远的经典。苹果视频特别策划了"港片经典重温"专题，精心挑选了数十部经典港片，让观众在超清修复画质下重新感受那段辉煌岁月。</p>
<h4>动作片经典</h4><p>从成龙大哥的《警察故事》系列到周润发的《英雄本色》，苹果视频收录了港片动作片中最具代表性的作品。经过专业修复后的画面，让这些经典之作焕发出新的生命力。</p>
<h4>喜剧片精选</h4><p>周星驰的无厘头喜剧、许氏兄弟的市井幽默，苹果视频为你一网打尽。这些陪伴了几代人成长的欢笑记忆，在苹果视频平台上一键即达。</p>
<h4>文艺片珍藏</h4><p>王家卫的《花样年华》、关锦鹏的《胭脂扣》，这些文艺片精品以其独特的艺术魅力影响着无数电影人。苹果视频以最高画质呈现这些视觉诗篇，让观众领略港片文艺之美。</p>
<h4>观影新体验</h4><p>苹果视频为每一部经典港片都配备了详细的影片介绍、幕后花絮和影评导读，让观众在观影的同时更深入地了解影片背后的故事。同时支持弹幕互动功能，让你可以和其他港片爱好者一起交流观影感受。</p>
<p>港片的黄金时代虽然已经远去，但那些经典作品永远不会褪色。打开苹果视频，让我们一起重温那些年的港片记忆！</p>`,
    category: 'pingguo',
    categoryName: '苹果视频',
    author: '糖心编辑',
    publishDate: '2026-07-08',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20Hong%20Kong%20cinema%20retro%20film%20abstract%20background%20with%20warm%20red%20and%20golden%20gradients%2C%20soft%20dreamy%20bokeh%20lights%2C%20classic%20movie%20atmosphere&width=800&height=450&seq=art-3&orientation=landscape',
    tags: ['苹果视频', '港片经典', '经典重温', '电影回忆'],
    views: 31200,
  },
  {
    id: 'art-4',
    title: '榴莲视频独家首播：《迷雾之城》悬疑大片引爆全网热议',
    slug: 'liulian-misty-city',
    excerpt: '榴莲视频独家首播悬疑大片《迷雾之城》，凭借烧脑剧情和精湛演技迅速引爆全网，上线三天播放量突破5000万次。',
    content: `<p>榴莲视频独家首播的悬疑大片《迷雾之城》自上线以来，凭借其扣人心弦的剧情和一流的制作水准，迅速在全网引发热议，上线仅三天播放量就突破了5000万次。</p>
<h4>剧情简介</h4><p>《迷雾之城》讲述了在一个常年被浓雾笼罩的北方城市中，接连发生了一系列离奇案件。刑警队长陈默在调查过程中发现，这些看似毫无关联的案件背后，隐藏着一个惊人的秘密。随着调查的深入，他发现自己也渐渐陷入了无法逃脱的迷雾之中。</p>
<h4>制作阵容</h4><p>该片由知名导演李明执导，实力派演员王强、刘佳领衔主演。导演李明以其独特的悬疑叙事风格著称，此次更是挑战极限，将故事的悬疑感和紧张氛围推向了新的高度。</p>
<h4>观众反响</h4><p>影片上线后，社交媒体上关于《迷雾之城》的讨论热度持续攀升。许多观众表示看完整部影片后"久久不能平静"，纷纷在各大平台上分享自己的观影感受和剧情解读。有人称赞剧情的精妙设计，有人感叹演员的精湛演技。</p>
<h4>为什么选择榴莲视频</h4><p>《迷雾之城》选择在榴莲视频独家首播，正是看中了榴莲视频平台对高品质内容的追求以及庞大的用户基础。榴莲视频的超清画质和流畅播放技术，确保了这部视觉大片能够以最佳状态呈现给观众。</p>
<p>如果你还没有看过《迷雾之城》，现在就来榴莲视频一睹为快吧！超清画质极速播放，让你沉浸在这座迷雾之城中，体验前所未有的悬疑之旅！</p>`,
    category: 'liulian',
    categoryName: '榴莲视频',
    author: '糖心编辑',
    publishDate: '2026-07-05',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20foggy%20city%20atmosphere%20abstract%20background%20with%20warm%20golden%20yellow%20gradients%2C%20soft%20dreamy%20bokeh%20lights%2C%20mysterious%20cinematic%20mood&width=800&height=450&seq=art-4&orientation=landscape',
    tags: ['榴莲视频', '独家首播', '悬疑大片', '迷雾之城'],
    views: 45800,
  },
  {
    id: 'art-5',
    title: '芒果视频夏日特辑：阳光沙滩与海风的治愈系纪录片推荐',
    slug: 'mangguo-summer-docs',
    excerpt: '芒果视频精选五部治愈系纪录片，带你领略世界各地的阳光沙滩与碧海蓝天，在炎炎夏日中感受一阵清凉的海风。',
    content: `<p>盛夏时节，芒果视频特别策划了"夏日治愈系"纪录片专题，精选了五部以海洋、阳光和自然为主题的纪录片，让你足不出户就能感受到世界各地的清凉与美好。</p>
<h4>1. 《蓝色星球：珊瑚海》</h4><p>这部高分纪录片以震撼的4K画质展现了珊瑚海的壮丽景观。五彩斑斓的珊瑚礁、灵动的热带鱼群，每一个画面都美得令人窒息。芒果视频提供的超清画质让这片蓝色天堂更加真实动人。</p>
<h4>2. 《地中海的夏天》</h4><p>跟随镜头走进意大利阿马尔菲海岸、希腊圣托里尼和西班牙伊比萨岛，感受地中海地区独特的夏日风情。碧蓝的海水、白色的建筑、金色的阳光，构成了一幅幅令人心旷神怡的画面。</p>
<h4>3. 《岛屿生活》</h4><p>这本纪录片聚焦于太平洋上几个远离尘嚣的小岛，记录当地人与自然和谐共处的生活方式。在快节奏的都市生活中，这些宁静的画面无疑是最好的心灵慰藉。</p>
<h4>4. 《冲浪者的天堂》</h4><p>从夏威夷到澳大利亚，从加州到巴厘岛，这部纪录片追踪了世界各地最著名的冲浪胜地。惊险刺激的冲浪画面配合舒缓的配乐，给人带来独特的视听享受。</p>
<h4>5. 《海边的咖啡馆》</h4><p>一部温馨治愈的短纪录片系列，每集介绍一家位于海边的独特咖啡馆。从日本镰仓到法国尼斯，每一家咖啡馆都有自己的故事和风景。芒果视频的暖色调画质完美呈现了这些温馨画面。</p>
<p>这个夏天，来芒果视频开启一场治愈系观影之旅吧！让阳光、沙滩和海风，为你带来一整天的好心情。</p>`,
    category: 'mangguo',
    categoryName: '芒果视频',
    author: '糖心编辑',
    publishDate: '2026-07-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20beach%20sunshine%20ocean%20abstract%20background%20with%20warm%20orange%20yellow%20gradients%2C%20soft%20dreamy%20bokeh%20lights%2C%20tropical%20healing%20atmosphere&width=800&height=450&seq=art-5&orientation=landscape',
    tags: ['芒果视频', '纪录片', '夏日特辑', '治愈系'],
    views: 14500,
  },
  {
    id: 'art-6',
    title: '糖果视频亲子时光：最适合全家一起观看的动画电影合集',
    slug: 'tangguo-family-anime',
    excerpt: '糖果视频为家庭用户精心挑选了最适合亲子共赏的动画电影，寓教于乐，让每一个家庭都能享受温馨甜蜜的观影时光。',
    content: `<p>家庭观影时光是最珍贵的记忆。糖果视频特别为家庭用户整理了一份亲子动画电影合集，每部影片都经过精心筛选，确保适合全家一起观看，既有趣味性又有教育意义。</p>
<h4>寓教于乐的精选片单</h4><p>糖果视频的亲子动画专区收录了来自全球的优秀动画作品，包括迪士尼经典、吉卜力名作以及优秀的国产动画。每部影片都配有详细的适龄推荐和内容介绍，帮助家长做出最合适的选择。</p>
<h4>安全健康的观影环境</h4><p>糖果视频为亲子专区设置了专门的儿童保护模式，自动过滤不适合儿童观看的内容，让家长可以放心地让孩子自主选择喜爱的动画。同时支持设置观看时长限制，帮助培养孩子良好的观影习惯。</p>
<h4>高品质的视听体验</h4><p>所有亲子动画影片均以超清画质呈现，色彩鲜艳饱满，画面细腻流畅。配合糖果视频优化的音效系统，动画中的每一个音乐和音效细节都得到了完美还原。</p>
<h4>互动与成长</h4><p>糖果视频还特别推出了"观影问答"功能，每部动画播放结束后，系统会弹出几个与影片内容相关的趣味问题，帮助孩子回顾和理解影片内容。这种寓教于乐的方式受到了家长和孩子们的一致好评。</p>
<p>周末闲暇时光，打开糖果视频，和孩子一起享受温馨甜蜜的亲子观影时光吧！</p>`,
    category: 'tangguo',
    categoryName: '糖果视频',
    author: '糖心编辑',
    publishDate: '2026-06-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20animation%20family%20friendly%20abstract%20background%20with%20warm%20candy%20colored%20gradients%2C%20soft%20dreamy%20bokeh%20lights%2C%20playful%20atmosphere&width=800&height=450&seq=art-6&orientation=landscape',
    tags: ['糖果视频', '亲子动画', '家庭观影', '儿童模式'],
    views: 9800,
  },
  {
    id: 'art-7',
    title: '糖心视频极速播放技术揭秘：如何实现零缓冲观影体验',
    slug: 'tangxin-tech-speed',
    excerpt: '糖心视频技术团队深度解析极速播放引擎背后的核心技术，从CDN加速到智能预加载，揭秘流畅观影体验的实现之道。',
    content: `<p>在视频平台上，没有什么比缓冲更让人沮丧的了。糖心视频的"极速播放"技术正是为了解决这一痛点而生的。今天，让我们走进糖心视频技术团队，揭秘零缓冲观影体验背后的核心技术。</p>
<h4>全球CDN加速网络</h4><p>糖心视频在全球部署了超过500个CDN节点，覆盖了亚洲、欧洲、北美、南美等主要地区。无论用户身处何地，系统都会自动选择距离最近的节点进行内容分发，将网络延迟降到最低。</p>
<h4>智能预加载算法</h4><p>糖心视频自研的智能预加载算法能够预测用户的观影行为，在用户观看当前片段的同时，提前加载后续内容。这一技术使得视频切换几乎无延迟，观影体验如丝般顺滑。</p>
<h4>自适应码率技术</h4><p>根据用户当前的网络状况，糖心视频的播放引擎会实时调整视频码率，在网络波动时自动切换至合适的清晰度，确保播放不会中断。当网络恢复后，又会自动切换回更高清的视频源。</p>
<h4>边缘计算架构</h4><p>糖心视频采用了先进的边缘计算架构，将部分计算任务从中心服务器分散到离用户更近的边缘节点。这不仅降低了服务器的负载，也大大缩短了用户请求的响应时间。</p>
<h4>播放器内核优化</h4><p>糖心视频技术团队对播放器内核进行了深度优化，包括解码效率提升、内存管理优化和GPU加速渲染等方面。经过优化的播放器在同等硬件条件下，播放性能提升了约40%。</p>
<p>技术的背后，是糖心视频对用户体验的极致追求。我们将继续投入研发，不断优化播放技术，为每一位用户带来更流畅、更高清的观影体验。</p>`,
    category: 'tangguo',
    categoryName: '糖果视频',
    author: '糖心科技',
    publishDate: '2026-06-20',
    imageUrl: 'https://readdy.ai/api/search-image?query=High%20speed%20streaming%20technology%20digital%20network%20abstract%20background%20with%20warm%20coral%20gradients%2C%20soft%20dreamy%20bokeh%20lights%2C%20tech%20innovation%20atmosphere&width=800&height=450&seq=art-7&orientation=landscape',
    tags: ['糖心视频', '极速播放', '技术揭秘', 'CDN加速'],
    views: 11200,
  },
  {
    id: 'art-8',
    title: '蜜桃视频新片速递：八月最值得期待的十部高清大片预告',
    slug: 'mitao-august-preview',
    excerpt: '蜜桃视频八月新片预告来袭，从国产科幻巨制到海外文艺佳作，十部重磅新片即将上线，提前锁定你的观影清单。',
    content: `<p>八月将至，蜜桃视频平台又将迎来一波新片潮。糖心视频提前为大家整理了十部即将在蜜桃视频上线的重磅大片，快来看看有没有你期待的吧！</p>
<h4>国产科幻：《太空救援队》</h4><p>讲述了中国航天员在太空中遭遇意外，展开一场惊心动魄的救援行动。特效制作精良，剧情紧凑有力，被誉为今年最值得期待的国产科幻片。</p>
<h4>海外文艺：《巴黎午夜》</h4><p>法国著名导演的新作，以巴黎为背景讲述了一段跨越时间的爱情故事。影片画面唯美，配乐动人，是文艺片爱好者的不容错过之作。</p>
<h4>日韩佳作：《樱花隧道》</h4><p>日本治愈系电影的代表作，以樱花季为背景，讲述了几个陌生人在樱花隧道中相遇的故事。温暖治愈，适合在夏日午后静静欣赏。</p>
<p>此外还有《深海探险队》、《古堡迷影》、《夏日奇迹》等多部精彩影片即将上线。记得锁定蜜桃视频，超清画质极速播放，八月观影季等你来！</p>`,
    category: 'mitao',
    categoryName: '蜜桃视频',
    author: '糖心编辑',
    publishDate: '2026-07-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=New%20movie%20preview%20cinema%20abstract%20background%20with%20warm%20peach%20gradients%2C%20soft%20dreamy%20bokeh%20lights%2C%20upcoming%20film%20atmosphere&width=800&height=450&seq=art-8&orientation=landscape',
    tags: ['蜜桃视频', '新片预告', '八月片单', '观影推荐'],
    views: 20100,
  },
];

export const faqs: FAQ[] = [
  {
    question: '糖心视频是什么？',
    answer: '糖心视频是一个汇聚蜜桃视频、桃子视频、苹果视频、榴莲视频、芒果视频、糖果视频等甜蜜水果品牌的高清在线视频平台。我们提供超清画质、极速播放的观影体验，让您随时随地享受精彩视频内容。',
  },
  {
    question: '糖心视频的画质如何？',
    answer: '糖心视频全平台支持超清画质播放，最高可达4K分辨率。我们采用先进的视频编码技术和AI画质增强算法，确保每一帧画面都清晰细腻、色彩饱满，为您带来影院级的观影享受。',
  },
  {
    question: '观看糖心视频需要付费吗？',
    answer: '糖心视频提供大量免费的精彩内容供用户观看。同时，我们也设有会员专区，会员用户可享受独家内容、去广告观影、优先观看新片等更多特权。具体收费标准请查看会员页面。',
  },
  {
    question: '糖心视频支持哪些设备？',
    answer: '糖心视频全面支持手机、平板、电脑等多种设备。您可以通过网页浏览器直接观看，也可以下载我们的移动应用，在iOS和Android设备上获得更优化的观影体验。',
  },
  {
    question: '为什么选择糖心视频？',
    answer: '糖心视频汇聚了蜜桃视频、桃子视频、苹果视频、榴莲视频、芒果视频和糖果视频六大品牌的海量内容，一次搜索即可找到您想看的影片。我们提供超清画质和极速播放技术，确保流畅的观影体验。同时，每日更新的内容库让您永远有新鲜内容可以观看。',
  },
  {
    question: '如何联系糖心视频客服？',
    answer: '您可以通过以下方式联系我们：客服邮箱 support@tangxinshipin.com，客服热线 400-888-6688，或访问我们的"关于我们"页面获取更多联系方式。我们的客服团队工作时间为每天9:00-21:00。',
  },
];

export const milestones: Milestone[] = [
  {
    year: '2018',
    title: '品牌创立',
    description: '糖心视频正式创立，以"甜蜜观影，幸福每一刻"为品牌理念，开启在线视频平台新征程。',
  },
  {
    year: '2019',
    title: '蜜桃视频上线',
    description: '旗下第一个品牌蜜桃视频正式上线，迅速获得用户喜爱，注册用户突破100万。',
  },
  {
    year: '2020',
    title: '多品牌布局',
    description: '桃子视频、苹果视频、榴莲视频相继上线，形成覆盖不同观影需求的品牌矩阵。',
  },
  {
    year: '2021',
    title: '技术突破',
    description: '自主研发极速播放引擎，实现超清画质下的零缓冲观影体验，获得行业技术大奖。',
  },
  {
    year: '2022',
    title: '用户破亿',
    description: '全平台累计注册用户突破1亿，日活跃用户超过2000万，成为行业领先视频平台。',
  },
  {
    year: '2023',
    title: '芒果视频&糖果视频',
    description: '芒果视频和糖果视频两大新品牌加入，内容生态更加丰富多元，覆盖全年龄段用户。',
  },
  {
    year: '2024',
    title: 'AI智能推荐',
    description: '推出基于AI的智能推荐系统，为用户精准匹配个性化内容，用户满意度大幅提升。',
  },
  {
    year: '2025',
    title: '全球化布局',
    description: '启动全球化战略，服务拓展至东南亚、日韩等地区，致力于成为全球领先的视频平台。',
  },
  {
    year: '2026',
    title: '持续创新',
    description: '持续技术创新和内容升级，4K超清画质成为标配，为用户带来前所未有的观影体验。',
  },
];

export const teamMembers: TeamMember[] = [
  {
    name: '张明远',
    role: '创始人 & CEO',
    bio: '连续创业者，深耕互联网视频行业15年，对视频技术和用户体验有着深刻的理解和执着的追求。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20man%20in%20modern%20business%20attire%2C%20warm%20lighting%2C%20clean%20background%2C%20friendly%20approachable%20expression%2C%20corporate%20headshot%20style&width=400&height=400&seq=team-1&orientation=squarish',
  },
  {
    name: '李雨桐',
    role: '首席技术官',
    bio: '前知名互联网公司技术总监，在视频编码和流媒体传输领域拥有多项核心专利技术。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20woman%20in%20modern%20tech%20attire%2C%20warm%20lighting%2C%20clean%20background%2C%20confident%20friendly%20expression%2C%20corporate%20headshot%20style&width=400&height=400&seq=team-2&orientation=squarish',
  },
  {
    name: '王思涵',
    role: '首席内容官',
    bio: '资深媒体人，曾任职于多家主流视频平台，拥有丰富的版权合作和内容策划经验。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20woman%20in%20modern%20creative%20attire%2C%20warm%20lighting%2C%20clean%20background%2C%20creative%20friendly%20expression%2C%20corporate%20headshot%20style&width=400&height=400&seq=team-3&orientation=squarish',
  },
];